import MBox from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const Container = styled("div")<{ isFullscreen?: boolean }>(({ isFullscreen }) => {
  return {
    display: "flex",
    flexDirection: isFullscreen ? "column" : "row",
    alignItems: isFullscreen ? undefined : "center",
    borderTopLeftRadius: "12px",
    borderTopRightRadius: "12px",

    position: "relative",
    paddingTop: "24px",
    paddingLeft: "24px",
    paddingRight: "24px",
    height: "auto",
    gap: "24px",
  };
});

export const Section = styled(MBox)(() => {
  return { display: "flex", alignItems: "center" };
});

export const ViewTitle = styled("div")(() => {
  return {
    fontSize: "22px",
    fontWeight: 600,
    color: colors.gray600,
    fontFamily: "Manrope, sans-serif",
    fontStyle: "normal",
    lineHeight: "28px",
    marginRight: 16,
  };
});
